import { render, staticRenderFns } from "./BrandEditorPopup.vue?vue&type=template&id=e4b9baa4&lang=html"
import script from "./BrandEditorPopup.vue?vue&type=script&lang=js"
export * from "./BrandEditorPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports